function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "10 10 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m25.377 21.175-.99 1.012c-.792.792-1.287 1.463-1.287 3.113h-2.2v-.55c0-1.221.495-2.321 1.287-3.113l1.364-1.386A2.15 2.15 0 0 0 24.2 18.7a2.2 2.2 0 1 0-4.4 0h-2.2a4.4 4.4 0 0 1 8.8 0 3.52 3.52 0 0 1-1.023 2.475ZM23.1 29.7h-2.2v-2.2h2.2v2.2ZM22 11a11 11 0 1 0 11 11c0-6.083-4.95-11-11-11Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgQuestionMark;